import React from 'react';
import ProfileSection from '../../components/ProfileSection/ProfileSection';
import formSchema from '../BasicInfoForm/schema';
import styles from './BasicInfoSection.module.css';
import layoutSchema from '../SpaceProfile/layoutSchema';
import { renderValue, renderCompoundValue } from '../../utils/renderFields';

const classNames = require('classnames');

export default function BasicInfoSection({ profile: data, fieldSettings, spaceProfilePhotos, setAssetImagesState }) {

  const InfoSection = props => {
    return props.children.some(_ => _) && <><div className={styles.infoHeader}>{props.name}</div><div className={classNames(styles.infoSection, 'd-flex flex-wrap')}>{props.children}</div></>;
  }

  //Value will be placed after the given key
  const insertValues = {
    'basic_info.size': data.basic_info.size && data.basic_info.client_provided_sq_ft ? <div key={'office_area_percent'} className={styles.infoItem}><b>Office Area (% of Total Sq Ft):</b> {parseFloat((data.basic_info.size / data.basic_info.client_provided_sq_ft * 100).toFixed(1))}%</div> : null
  };

  return layoutSchema.categories.map((category, i) => {
    const layout = category.sections.map(section => {
      let subsections = section.subsections.map(subsection => {
        if (subsection.compound) {
          const key = subsection.keys[0].split('.').slice(0, subsection.keys[0].split('.').length - 1).join('.');
          return renderCompoundValue(key, data, fieldSettings, formSchema, subsection.label, spaceProfilePhotos, setAssetImagesState);
        }
        return subsection.keys.map(subsectionKey => {
          if (subsection.excludeKeysViewMode && subsection.excludeKeysViewMode.includes(subsectionKey)) return null;
          return renderValue(subsectionKey, data, fieldSettings, formSchema, spaceProfilePhotos, setAssetImagesState)
        })
      })
      subsections.flat();

      let sectionFields = section.keys.map(sectionKey => {
        if (section.excludeKeysViewMode && section.excludeKeysViewMode.includes(sectionKey)) return null;
        return renderValue(sectionKey, data, fieldSettings, formSchema, spaceProfilePhotos, setAssetImagesState)
      });

      sectionFields = sectionFields.filter(_ => _);
      subsections = subsections.filter(_ => _);

      Object.keys(insertValues).forEach(key => {
        let index;
        sectionFields.forEach((section, i) => {
          if (key === section.key) index = i
        });
        if (index) sectionFields.splice(index, 0, insertValues[key]);
      })

      if (!sectionFields.length && !subsections.length) return null;

      return <InfoSection key={section.viewModeLabel || section.label} name={section.viewModeLabel || section.label}>
        {sectionFields}
        {subsections}
      </InfoSection>
    })

    return <ProfileSection key={category.id} section={category.id} hideCategoryLabel={category.hideCategoryLabel} label={category.viewModeLabel || category.label}>
      {layout}
    </ProfileSection>
  })
}

